/* eslint-disable jsx-a11y/iframe-has-title */
import {
  AppBar,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  Container,
  Grid,
  Stack
} from "@mui/material";

import Iframe from 'react-iframe'

import MenuIcon from "@mui/icons-material/Menu";
import React from "react";
import { Outlet, Link } from "react-router-dom";
import LOGO from "../../assets/sofn-loogo-2021-white.png";
import './header-app.styles.scss';


const drawerWidth = 240;
const navItems = [
  { name: "Map", ref: "/" },
  { name: "List", ref: "district" },
];

const HeaderApp = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };



  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 0 }} style={{
        color: "white",
        backgroundColor: "#4bb1ca"
      }}>
        Sons of Norway Lodge Directory
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }} key={item.name} component={Link} to={item.ref}>
              <ListItemText primary={item.name} />
              <Divider />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  return (
    <div >
      <Box sx={{ display: 'flex' }}>
        <Box component="nav">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "flex", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <AppBar component="nav" position="relative">
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Box pt={{ xs: 0, sm: 0 }}
              component="img"
              sx={{
                flexGrow: 0,
                m: "40px",
                height: 60,
                maxWidth: 250
              }}
              alt="Your logo."
              src={LOGO}
            ></Box>
            <Box sx={{ textAlign: "center", flexGrow: 1, display: {  xs: "none", sm: "block" } }}>
            {<Typography
              variant="h4"
              component="div"
            >
              Sons of Norway Lodge Directory
            </Typography>}
            </Box>

            <Stack spacing={1}  direction="row" sx={{ display: { xs: "none", sm: "flex" } }}>
              {navItems.map((item) => (
                <Button variant="contained" className="sonsBt"
                  key={item.name}
                 
                  component={Link}
                  to={item.ref}
                >
                  {item.name}
                </Button>
              ))}
            </Stack>
          </Toolbar>
        </AppBar>
      </Box>
      <Outlet />
    </div>
  );
};

export default HeaderApp;
